import { z } from 'zod';

/**
 * Cognito Password Field
 *
 * Zod validator for the admin user pool's password policy: 8+ characters with
 * at least one uppercase letter, lowercase letter, number, and special
 * character. Shared by the login NEW_PASSWORD_REQUIRED challenge and the
 * forgot-password reset form so the rules stay in lockstep if the pool policy
 * changes.
 */
export const cognitoPasswordField = z
  .string()
  .min(8, 'Password must be at least 8 characters')
  .regex(/[A-Z]/, 'Password must contain at least one uppercase letter')
  .regex(/[a-z]/, 'Password must contain at least one lowercase letter')
  .regex(/[0-9]/, 'Password must contain at least one number')
  .regex(/[^A-Za-z0-9]/, 'Password must contain at least one special character');
